import { TFunction } from 'i18next';
import { FilterConfiguration } from 'stores/common/Filters';
import flatMap from 'lodash/flatMap';
import { VocabularyNamespaces } from 'types';
import { LiveClassOfferingAggregate } from 'types/liveClass';

export type RangeFilter<T> = {
  from: T | undefined;
  to: T | undefined;
};

/**
 * Returns the filter configurations for the live class offerings.
 * @returns The filter configurations.
 */
export const getFilterConfigurations = (
  t: TFunction = (str: string) => str,
): FilterConfiguration<LiveClassOfferingAggregate>[] => {
  const filterConfigurations = [];
  filterConfigurations.push({
    key: 'languages',
    title: t('Languages'),
    vocabularyNamespace: VocabularyNamespaces.InstructionLanguages,
    extractFilterValues: (entries) =>
      flatMap(
        entries,
        (extendedEntry: LiveClassOfferingAggregate) =>
          extendedEntry.instruction_language,
      ),
    validateEntry: (entries, checkedLanguages) =>
      checkedLanguages.includes(entries.instruction_language),
  } as FilterConfiguration<LiveClassOfferingAggregate>);

  return filterConfigurations;
};
